import { isEqual } from "./parse";

export function isOwner(role) {
  return isEqual(role.user_role, "Owner");
}